<app-pet-rehome-modal-header [redirectTo]="'/dashboard'"></app-pet-rehome-modal-header>

<div class="modal-body">
  <div class="row mt-2">
    <div class="col-12">
      <p>
        Thank you for your payment.
      </p>
      <p>
        Your transfer of keepership request has been successfully submitted.
      </p>
      <p>
        We will shortly begin running our security checks on the microchip
        and gaining permission from the current registered keeper to relinquish
        keepership, this may take up to 28 working days. If we do not receive
        confirmation from the previous keeper in this time frame, your request
        will be automatically approved.
      </p>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="onConfirm()">
    Got it
  </button>
</div>
